import styled from 'styled-components';
import { FieldWrapper, Tag } from 'components';
import { theme, toRem } from 'design';

export const ActionSection = styled.section`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-top: ${toRem(14)};
  width: 100%;

  button {
    width: 48%;
    height: ${toRem(34)};
    font-size: ${toRem(11)};
    font-weight: ${theme.font.weight.semiBold};

    @media (max-width: ${theme.breakpoint.small}px) {
      width: 100%;
      margin: ${toRem(8)} 0;
    }

    &:disabled {
      color: ${theme.color.neutral[400]};
      background-color: ${theme.color.neutral[200]};

      &:hover {
        color: ${theme.color.neutral[400]};
        background-color: ${theme.color.neutral[200]};
      }
    }
  }
`;

export const StyledFieldWrapper = styled(FieldWrapper)`
  label {
    font-size: ${toRem(14)};
  }
`;

export const StyledTag = styled(Tag)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: ${toRem(16)};
  font-size: ${toRem(12)};
  text-transform: none;
`;
